// Script to handle menuPages
// Handle show/hide of menu with all pages

// Get menu element
const BwMenuPages = document.querySelector("[data-item='BW-navigation-menu']")

// Check if menu exists
if (BwMenuPages) {
  // Show/hide on button with menu icon
  document
    .querySelectorAll("[data-item='BW-navigation-button']")
    .forEach((btn) =>
      btn.addEventListener('click', () => {
        if (BwMenuPages && isHTMLElement(BwMenuPages)) {
          // Check if menu is visible
          if (BwMenuPages.classList.contains('visible') !== true) {
            // If true -> animate show
            BwMenuPages.classList.add('visible')
            BwMenuPages.style.opacity = '1'
          } else {
            // If false -> animate hide
            BwMenuPages.style.opacity = '0'
            setTimeout(() => {
              BwMenuPages.classList.remove('visible')
            }, 310)
          }
        }
      }),
    )

  // Hide on button 'X" click
  document
    .querySelectorAll("[data-action='BW-navigation-hide']")
    .forEach((btn) =>
      btn.addEventListener('click', () => {
        if (BwMenuPages && isHTMLElement(BwMenuPages)) {
          // Animate hide
          BwMenuPages.style.opacity = '0'
          setTimeout(() => {
            BwMenuPages.classList.remove('visible')
          }, 310)
        }
      }),
    )
}

const isHTMLElement = (el: Element): el is HTMLElement => {
  if (el instanceof HTMLElement) {
    return true
  }

  return false
}
